(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('CustomSegmentCustomersManageModalController', CustomSegmentCustomersManageModalController);

    CustomSegmentCustomersManageModalController.$inject = ['$scope', 'customSegments', 'CustomSegmentsService', 'SettingsService', 'close'];

    function CustomSegmentCustomersManageModalController($scope, customSegments, CustomSegmentsService, SettingsService, close) {
        var vm = this;

        vm.customers = [];
        vm.customSegmentName = customSegments.length == 1 ? customSegments[0].name : "Editing customer accounts for " + customSegments.length + " custom segments";
        vm.allowed = [];
        vm.action = 'update';
        vm.selectedCustomer = null;

        angular.forEach(customSegments, function (customSegment) {
            if (customSegment.hasOwnProperty('allowed')) {
                angular.forEach(customSegment.allowed, function (allowed) {
                    if (!_.contains(vm.allowed, allowed)) vm.allowed.push(allowed);
                });
            }
        });

        // prepare promise for the list of all customers
        var customersPromise = CustomSegmentsService.getcustomers().$promise;
        customersPromise.then(function (response) {
            // No need to show your own company in the list of customers,
            // since you always have access to your own segments
            var currentCustomerId = SettingsService.getCompanyId();
            vm.customers = _.filter(response.data, function (customer) {
                return customer['id'] != currentCustomerId;
            });
        });

        vm.selectCustomer = function (customer) {
            vm.selectedCustomer = customer;
            return false;
        };

        vm.add = function (customer) {
            if (isAllowed(customer)) {
                //console.log('customer already allowed');
                return;
            }
            vm.allowed.push(customer);
            $scope.customSegmentCustomersForm.$pristine = false;
        };

        function isAllowed(customer) {
            return _.contains(_.pluck(vm.allowed, 'id'), customer['id']);
        }

        vm.remove = function (customer) {
            vm.allowed = _.filter(vm.allowed, function (c) {
                return c.id != customer.id;
            });
            $scope.customSegmentCustomersForm.$pristine = false;
        };

        vm.save = function () {
            close({
                action: vm.action,
                allowed: vm.allowed
            }, 500);
        };

        vm.allowSave = function () {
            var allowSave = false;
            angular.forEach(customSegments, function (customSegment) {
                if (angular.isUndefined(customSegment.allowed) && vm.allowed.length > 0) allowSave = true;
                if (angular.isDefined(customSegment.allowed) && !angular.equals(vm.allowed, customSegment.allowed))  allowSave = true;
            });
            return allowSave;
        };

    }
})();